export interface Project {
  publicId: string;
  name: string;
  description: string | null;
  instructions: string | null;
  sessionCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface ProjectList {
  items: Project[];
  /** False when the current package does not include projects. */
  enabled: boolean;
  /** Max projects allowed by the package; null = unlimited. */
  limit: number | null;
  canCreate: boolean;
}

export interface ProjectFormValues {
  name: string;
  description: string;
}

/** Partial update: only the provided fields are changed. */
export type ProjectUpdateValues = Partial<ProjectFormValues & { instructions: string }>;

/** DataTransfer type used when dragging a conversation onto a project. */
export const CONVERSATION_DRAG_TYPE = 'application/x-appaihelp-conversation';
